export const siteData=["NSW-Auburn", "QLD-Crestmead","SA-Pooraka", "TAS", "VIC-Kensington","WA-Canning Vale"]
export const server="https://d.thefruitboxgroup.com.au/invoice/v1/"